export default __webpack_public_path__ + "static/banksmilessingleline-05d68e882d6f02b0ce9975127d08daf9.woff2";